import Vue from "vue"
import VueRouter from "vue-router"
import Dashboard from "@/views/Dashboard.vue"
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: Dashboard,
    meta: { requiresAuth: true },
    children: [
      { path: "", component: () => import("@/views/Landing.vue") },
      { path: "tasks", component: () => import("@/views/TaskBoard.vue") },
      { path: "planning", component: () => import("@/views/PlanningGrid.vue") },
      { path: "fiches", component: () => import("@/views/FichesTab.vue") },
      { path: "priorites", component: () => import("@/views/PriorityTab.vue") },
      { path: "calendar", component: () => import("@/views/CalendarView.vue") },
    ],
  },
  { path: "/setup", component: () => import("@/views/GardenSetup.vue"), meta: { requiresAuth: true } },
  { path: "/intro", component: () => import("@/views/Intro.vue") },
  { path: "/login", component: () => import("@/views/Login.vue") },
  { path: "/register", component: () => import("@/views/Register.vue") },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, _from, next) => {
  const requiresAuth = to.matched.some((r) => r.meta?.requiresAuth)
  const isLoggedIn = store.getters["auth/isLoggedIn"]

  if (requiresAuth && !isLoggedIn) {
    return next({ path: "/login", query: { next: to.fullPath } })
  }
  if ((to.path === "/login" || to.path === "/register") && isLoggedIn) {
    return next("/")
  }
  next()
})

export default router
